import * as React from "react";
import { memo } from "react";
import styled, { ThemeContext } from "styled-components";
import { themeGet } from "@styled-system/theme-get";
import { Text } from "pcln-design-system";
const IconWrapper = /*#__PURE__*/styled(Text).withConfig({
  displayName: "CruisesDark__IconWrapper",
  componentId: "sc-twbwel-0"
})(["display:inline-block;"]);
function BaseComponent({
  title,
  titleId,
  ...props
}) {
  const themeContext = React.useContext(ThemeContext);
  const themeProps = {
    theme: themeContext
  };
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: false,
    "aria-hidden": true,
    role: "img",
    "aria-labelledby": titleId,
    ...props
  }, title ? React.createElement("title", {
    id: titleId
  }, title) : null, React.createElement("g", {
    clipPath: "url(#CruisesDark_tsx__clip0_713_10423)"
  }, React.createElement("path", {
    d: "M31.46 27.726c-.879.017-1.77-.281-2.27-.896a3.756 3.756 0 00-5.811 0 2.85 2.85 0 01-4.408 0 3.756 3.756 0 00-5.81 0 2.85 2.85 0 01-4.408 0 3.756 3.756 0 00-5.811 0c-.491.597-1.349.896-2.202.896",
    stroke: themeGet("palette.background.darkest")(themeProps),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M5.787 12.14V8.198h2.176v3.037",
    fill: themeGet("palette.background.darkest")(themeProps)
  }), React.createElement("path", {
    d: "M5.787 12.14V8.198h2.176v3.037M.74 27.726l.836-6.758 13.978-5.163c3.247-1.173 6.178-1.203 9.71-1.438l6.136-.41s.572 4.647-1.941 6.759c-2.74 2.3-3.064 4.638-3.064 4.638",
    stroke: themeGet("palette.background.darkest")(themeProps),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M2.775 20.366l.478-3.759 11.4-4.394a15.788 15.788 0 015.667-1.054h5.218l.866 2.773",
    stroke: themeGet("palette.background.darkest")(themeProps),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M4.209 16.236l.41-3.605 8.814-3.674a11.822 11.822 0 014.536-.909h3.648l.99 3.11",
    stroke: themeGet("palette.background.darkest")(themeProps),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M10.28 10.267V6.47h2.138v2.91",
    fill: themeGet("palette.background.darkest")(themeProps)
  }), React.createElement("path", {
    d: "M10.28 10.267V6.47h2.138v2.91",
    stroke: themeGet("palette.background.darkest")(themeProps),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "CruisesDark_tsx__clip0_713_10423"
  }, React.createElement("path", {
    fill: themeGet("palette.background.lightest")(themeProps),
    transform: "translate(.1 5.83)",
    d: "M0 0h32v27.341H0z"
  }))));
}
const CruisesDark = props => React.createElement(IconWrapper, {
  fontSize: props.size,
  lineHeight: props.size,
  verticalAlign: "middle",
  className: props.className
}, React.createElement(BaseComponent, null));
/** @public */
const Memo = memo(CruisesDark);
export default Memo;